export const EXTENSIONS_TAB_TYPE = {
  THIRD_PARTY_TOOLS: 'third-party-tools',
  EARN_OPTIONS: 'earn-options'
}

export const EXTENSIONS_TAB_CONTENT_ID = {
  THIRD_PARTY_TOOLS: 0,
  EARN_OPTIONS: 1
}

export const THIRD_PARTY_TOOLS_TYPE_FILTERS = {
  ALL: 'all',
  ECOMMERCE: 'ecommerce',
  CRM: 'crm',
  ANALYTICS: 'analytics',
  PAYMENT: 'payment',
  LOYALTY_PROGRAM_PROVIDERS: 'loyalty-program-providers',
  POS_SOFTWARE: 'pos-software'
}
